import {
  AttachmentType,
  AttachmentUploadStatus,
} from '../../../../../shared/editor/types';

export const getFormattedAttachmentsData = (
  existingAttachments: any[],
  status: AttachmentUploadStatus = AttachmentUploadStatus.Existing,
): AttachmentType[] => {
  const attachments = [];

  if (existingAttachments && existingAttachments.length) {
    existingAttachments.forEach((item) => {
      const attachment: AttachmentType = {
        attachmentId: item.attachmentId,
        file: {
          name: item.attachment.name,
          size: Number(item.attachment.size),
        },
        status,
      };
      attachments.push(attachment);
    });

    return attachments;
  }

  return [];
};
